import type { HttpClient } from './http';

export interface InstalledPackage {
  id: number | null;
  source: string;
  packageName: string | null;
  nodeName: string | null;
  taskName: string | null;
  category: string | null;
}

export interface CreateInstalledPackagePayload {
  source?: string;
  packageName: string;
  nodeName: string;
  taskName?: string | null;
  category?: string | null;
}

export interface InstalledPackagesApi {
  list(): Promise<InstalledPackage[]>;
  create(payload: CreateInstalledPackagePayload): Promise<InstalledPackage>;
  remove(id: number): Promise<void>;
}

export function createInstalledPackagesApi(
  http: HttpClient
): InstalledPackagesApi {
  return {
    list: () => http.get<InstalledPackage[]>('/installed-packages'),
    create: (payload: CreateInstalledPackagePayload) =>
      http.post<InstalledPackage>('/installed-packages', payload),
    remove: (id: number) => http.delete<void>(`/installed-packages/${id}`),
  };
}
